const EMPTY_STRING = '';
const EMPTY_OBJECT = {};
let usersResponseStateful = EMPTY_OBJECT;

function getUsersResponseStateful() {
    const {membership, displayName, userDTO} = usersResponseStateful;
    return {
        isMembership: () => membership ?? false,
        getDisplayName: () => displayName ?? EMPTY_STRING,
        getUserDTO: () => userDTO ?? EMPTY_OBJECT,
        isPresent: () => usersResponseStateful !== EMPTY_OBJECT,
    };
}
function setUsersResponseStateful(usersResponse) {
    if (usersResponse !== null && usersResponse !== undefined) {
        usersResponseStateful = usersResponse;
    } else {
        throw new Error('Users Response can\'t be null or undefined');
    }
}

function wipeUsersResponseStateful() {
    usersResponseStateful = EMPTY_OBJECT;
}

module.exports = {
    getUsersResponseStateful,
    setUsersResponseStateful,
    wipeUsersResponseStateful,
};
